(() => {
  if (window.__qlsPackageProtectionCheckoutInstalled) return;
  window.__qlsPackageProtectionCheckoutInstalled = true;

  let queued = false;
  let applying = false;

  const moneyMatches = (text) =>
    String(text || '').match(/(?:US\s*)?\$\s*[\d,]+(?:\.\d{2})?/g) || [];

  const moneyValue = (text) => {
    const value = Number(String(text || '').replace(/[^\d.-]/g, ''));
    return Number.isFinite(value) ? value : null;
  };

  const formatUsd = (value) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);

  function updateContainer(container) {
    const label = container.querySelector('.ssp-checkout-text');
    const primary = container.querySelector('.ssp-checkout-button');
    const secondary = container.querySelector('.ssp-checkout-link');
    if (!label || !primary || !secondary) return;

    const planElement = primary.querySelector('.insurance_plan');
    const planMatch = moneyMatches(planElement?.textContent || label.textContent)[0];
    const buttonMatches = moneyMatches(primary.textContent);
    const plan = moneyValue(planMatch);

    let base = null;
    if (buttonMatches.length > 1) {
      const values = buttonMatches.map(moneyValue).filter((value) => value !== null);
      base = values.find((value) => plan === null || Math.abs(value - plan) > 0.0001);
    }

    if (base === null) {
      base = moneyValue(container.dataset.qlsBasePrice);
    }
    if (plan === null || base === null) return;

    container.dataset.qlsBasePrice = String(base);
    container.dataset.qlsPlanPrice = String(plan);

    const labelText = `Package Protect • ${formatUsd(plan)}`;
    const protectedTotal = formatUsd(base + plan);
    const primaryText = `Checkout + Package Protect • ${protectedTotal}`;
    const secondaryText = `Checkout without package protection • ${formatUsd(base)}`;

    if (label.textContent.trim() !== labelText || !label.querySelector('.qls-pp-label-mark')) {
      label.innerHTML =
        '<span class="qls-pp-label-mark" aria-hidden="true">' +
          '<svg viewBox="0 0 38 30" focusable="false">' +
            '<path class="qls-pp-mark__box" d="M7.5 11 19 5.2 30.5 11 19 16.8 7.5 11Zm0 0v10.7L19 27.2V16.8L7.5 11Zm23 0v10.7L19 27.2V16.8L30.5 11Z"/>' +
            '<path class="qls-pp-mark__tape" d="m13.2 8.1 11.7 5.8v5.2"/>' +
            '<circle class="qls-pp-mark__badge" cx="29.5" cy="7.4" r="6.1"/>' +
            '<path class="qls-pp-mark__check" d="m26.8 7.4 1.8 1.8 3.7-4"/>' +
          '</svg>' +
        '</span>' +
        '<span>Package Protect • ' + formatUsd(plan) + '</span>';
    }
    if (primary.dataset.qlsProtectedTotal !== protectedTotal || !primary.querySelector('.qls-pp-mark')) {
      primary.innerHTML =
        '<span class="qls-protected-checkout-label">Checkout +</span>' +
        '<span class="qls-pp-mark" aria-hidden="true">' +
          '<svg viewBox="0 0 38 30" focusable="false">' +
            '<path class="qls-pp-mark__box" d="M7.5 11 19 5.2 30.5 11 19 16.8 7.5 11Zm0 0v10.7L19 27.2V16.8L7.5 11Zm23 0v10.7L19 27.2V16.8L30.5 11Z"/>' +
            '<path class="qls-pp-mark__tape" d="m13.2 8.1 11.7 5.8v5.2"/>' +
            '<circle class="qls-pp-mark__badge" cx="29.5" cy="7.4" r="6.1"/>' +
            '<path class="qls-pp-mark__check" d="m26.8 7.4 1.8 1.8 3.7-4"/>' +
          '</svg>' +
        '</span>' +
        '<span class="qls-protected-checkout-price">• ' + protectedTotal + '</span>';
      primary.dataset.qlsProtectedTotal = protectedTotal;
    }
    if (secondary.textContent.trim() !== secondaryText) secondary.textContent = secondaryText;
    if (primary.getAttribute('aria-label') !== primaryText) primary.setAttribute('aria-label', primaryText);
    if (secondary.getAttribute('aria-label') !== secondaryText) secondary.setAttribute('aria-label', secondaryText);
  }

  function apply() {
    queued = false;
    if (applying) return;
    applying = true;
    document.querySelectorAll('.ssp-checkout-button-container').forEach(updateContainer);
    applying = false;
  }

  function schedule() {
    if (queued || applying) return;
    queued = true;
    window.requestAnimationFrame(apply);
  }

  const observer = new MutationObserver(schedule);
  const start = () => {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    schedule();
  };

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });

  document.addEventListener('dispatch:cart-drawer:refresh', () => window.setTimeout(schedule, 80));
  document.addEventListener('cart:updated', () => window.setTimeout(schedule, 80));
})();
